import * as React from 'react';
import { useSelector } from 'react-redux';
import { ContactsModalWindow } from '../../components/ContactsModalWindow';
import { selectConsultantPhone } from '../../selectors/consultantContacts';

export interface IContactsModalWindowContainerProps {
  onClose: () => void;
  open: boolean;
}

export const ContactsModalWindowContainer: React.FC<IContactsModalWindowContainerProps> = ({ onClose, open }) => {
  const phone = useSelector(selectConsultantPhone);

  return <ContactsModalWindow onClose={onClose} open={open} phone={phone} />;
};
